import { Alert } from 'antd';
import type { AlertProps } from 'antd';

export const StyledAlert = (props: AlertProps) => {
	return <Alert showIcon className="styled-alert" {...props} />;
};
